export default __webpack_public_path__ + "static/market-index-treemap-62671814690719083221117cd1c476b7.png";